import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Assessment from "./components/features/landingScreen/Interview";
import Login from "./components/features/login/Login";
import OTP from "./components/features/login/OTP";
import Camera from "./components/features/login/Camera";
import Loader from "./components/features/login/Loader";
import Welcome from "./components/features/welcome/Welcome";
import SlotBooking from "./components/features/welcome/SlotBooking.jsx";
import PublicWelcome from "./components/features/welcome/PublicWelcome";
import WelcomeResponse from "./components/features/welcome/WelcomeResponse";
import { WelcomeProvider } from "./contexts/WelcomeContext";
import ScreenupLogin from "./components/features/login/Screenuplogin";
import ScreenupOTP from "./components/features/login/ScreenupOTP";
import CaptchaVerification from "./components/features/login/CaptchaScreen";
import Information from "./components/features/login/Information";
import Verification from "./components/features/login/Verification";
import AssessmentInegrity from "./components/features/login/AssessmentInegrity";
import Authentication from "./components/features/login/Authentication";
import AssessmentSuccess from "./components/features/landingScreen/AssessmentSuccess";
import MoonshotsIntroduction from "./components/features/login/MoonshotsIntroduction";
import MoonshotsSetup from "./components/features/login/MoonshotsSetup";
import Moonshots from "./components/features/login/Moonshots";
import MoonshotsTakingPictures from "./components/features/login/MoonshotsTakingPictures";
import AllSet from "./components/features/login/AllSet";
import ConnectionRestored from "./components/features/landingScreen/ConnectionRestored";
import { encryptToken } from "./utils/decryptURL";
import SurveyForm from "./components/features/landingScreen/SurveyForm";
import ContactSupportPage from "./components/commonComponents/ContactSupportPage";
import NeedleEyeDesktopIntroduction from "./components/features/login/NeedleEyeDesktopIntroduction";
import NeedleEyeDesktopSetup from "./components/features/login/NeedleEyeDesktopSetup";
import NeedleEyeDesktopAuthenticate from "./components/features/login/NeedleEyeDesktopAuthenticate";
import InterviewNotYetOpen from "./components/features/login/InterviewNotYetOpen";
import ProtectedRoute from "./ProtectedRoute.jsx";
import SlotBookingLogin from "./components/features/login/SlotBookingLogin.js";
import SlotBookingOTP from "./components/features/login/SlotBookingOtp.js";
import DemoVideoPage from "./components/features/login/DemoVideoPage.jsx";

const App = () => {
  console.log("444444");
  encryptToken("c64fdffd-486c-44fb-ab23-419a984b5d9e").then(console.log);
  console.log("444444");
  return (
    <WelcomeProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/welcome" />} />
          <Route path="/welcome" element={<Welcome />} />

          <Route path="/welcome-response" element={<WelcomeResponse />} />
          <Route path="/slot-booking" element={<SlotBooking />} />

          <Route path="/login" element={<Login />} />
          <Route path="/candidate-welcome/:hash" element={<PublicWelcome />} />
          <Route path="/screenup-login" element={<ScreenupLogin />} />
          <Route path="/screenup-otp" element={<ScreenupOTP />} />
          <Route path="/slot-booking-login" element={<SlotBookingLogin />} />
          <Route path="/slot-booking-otp" element={<SlotBookingOTP />} />
          <Route path="/otp" element={<OTP />} />
          <Route path="/interview-not-open" element={<InterviewNotYetOpen />} />
          <Route
            path="/captcha-verification"
            element={<CaptchaVerification />}
          />
          <Route path="/loader" element={<Loader />} />
          <Route
            path="/assessment"
            element={
              <ProtectedRoute>
                <Assessment redirectFrom="allSet" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/camera"
            element={
              <ProtectedRoute>
                <Camera />
              </ProtectedRoute>
            }
          />
          <Route
            path="/assessment-integrity"
            element={
              <ProtectedRoute>
                <AssessmentInegrity />
              </ProtectedRoute>
            }
          />
          <Route
            path="/needleeye-setup"
            element={
              <ProtectedRoute>
                <MoonshotsSetup />
              </ProtectedRoute>
            }
          />
          <Route
            path="/authentication"
            element={
              <ProtectedRoute>
                <Authentication />
              </ProtectedRoute>
            }
          />
          <Route
            path="/information"
            element={
              <ProtectedRoute>
                <Information />
              </ProtectedRoute>
            }
          />
          <Route
            path="/demo-video"
            element={
              <ProtectedRoute>
                <DemoVideoPage/>
              </ProtectedRoute>
            }
          />
          <Route
            path="/verification"
            element={
              <ProtectedRoute>
                <Verification />
              </ProtectedRoute>
            }
          />
          <Route
            path="/assessment-success"
            element={
              <ProtectedRoute>
                <AssessmentSuccess />
              </ProtectedRoute>
            }
          />
          <Route path="/survey" element={<SurveyForm />} />
          <Route
            path="/needleeye-introduction"
            element={
              <ProtectedRoute>
                <MoonshotsIntroduction />
              </ProtectedRoute>
            }
          />
          <Route path="/needleeye" element={<Moonshots />} />
          <Route
            path="/needleeye-taking-pictures"
            element={
              <ProtectedRoute>
                <MoonshotsTakingPictures />
              </ProtectedRoute>
            }
          />
          <Route
            path="/all-set"
            element={
              <ProtectedRoute>
                <AllSet />
              </ProtectedRoute>
            }
          />
          <Route
            path="/connection-restored"
            element={
              <ProtectedRoute>
                <ConnectionRestored />
              </ProtectedRoute>
            }
          />
          <Route path="/contact-support" element={<ContactSupportPage />} />
          {/* NeedleEye Desktop Agent Flow */}
          <Route
            path="/needleeye-desktop-introduction"
            element={
              <ProtectedRoute>
                <NeedleEyeDesktopIntroduction />
              </ProtectedRoute>
            }
          />
          <Route
            path="/needleeye-desktop-setup"
            element={
              <ProtectedRoute>
                <NeedleEyeDesktopSetup />
              </ProtectedRoute>
            }
          />
          <Route
            path="/needleeye-desktop-authenticate"
            element={
              <ProtectedRoute>
                <NeedleEyeDesktopAuthenticate />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </WelcomeProvider>
  );
};

export default App;
